import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FEED_FORMATS = [
  {
    title: "Single Post Embed",
    code: '<script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-post="bytehype/1" data-width="100%"></script>',
    description: "Embed a single post from your Telegram channel"
  },
  {
    title: "Channel Feed",
    code: '<script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-discussion="bytehype" data-limit="5" data-width="100%"></script>',
    description: "Display multiple posts from your channel in a scrollable feed"
  },
  {
    title: "Channel Preview Card",
    code: '<script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-discussion="bytehype" data-color="343638" data-dark="1" data-dark-color="FFFFFF"></script>',
    description: "Show a preview card of your channel with join button"
  },
  {
    title: "Join Channel Button",
    code: '<script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-login="bytehype" data-size="large" data-auth-url="https://your-domain.com/auth"></script>',
    description: "Add a join channel button to your website"
  }
];

export const FeedFormatOptions = () => {
  const { toast } = useToast();

  const handleCopyCode = (code: string) => {
    navigator.clipboard.writeText(code);
    toast({
      title: "Copied!",
      description: "Feed format code copied to clipboard",
    });
  };

  return (
    <Card className="p-4 sm:p-6 bg-black/50 backdrop-blur-sm border-gray-800">
      <h2 className="text-xl font-bold text-white mb-4">Feed Format Options</h2>
      <Accordion type="single" collapsible className="space-y-2">
        {FEED_FORMATS.map((format, index) => (
          <AccordionItem 
            key={index} 
            value={`format-${index}`}
            className="bg-black/30 rounded-lg border border-gray-800"
          >
            <AccordionTrigger className="px-4 py-2 text-white hover:no-underline">
              {format.title}
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-4">
              <p className="text-gray-400 mb-3">{format.description}</p>
              <div className="bg-black/70 p-3 rounded-md mb-3">
                <code className="text-xs sm:text-sm break-all text-gray-300">
                  {format.code}
                </code>
              </div>
              <Button
                onClick={() => handleCopyCode(format.code)}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white hover:opacity-90"
              >
                Copy Code
              </Button>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Card>
  );
};